import { X } from "lucide-react";

export type UploadResult = {
  status: string;
  notice: string | null;
};

// The upload dialog closes on success. The outcome has to live on the caller
// (the layer row, or the work-order list) or it disappears with the dialog.
// A partial-results warning stays until the person dismisses it.
export function UploadResultNote({
  result,
  onDismissNotice,
  compact = false,
}: {
  result: UploadResult | null;
  onDismissNotice: () => void;
  compact?: boolean;
}) {
  if (!result) return null;
  const statusClass = compact
    ? "px-1 pb-0.5 text-[9px] leading-tight text-emerald-300"
    : "mt-2 text-xs text-emerald-400";
  const noticeClass = compact
    ? "flex items-start gap-1 px-1 pb-0.5 text-[9px] leading-tight text-amber-300"
    : "mt-1 flex items-start gap-2 text-xs text-amber-400";
  return (
    <div>
      {result.status ? (
        <p role="status" className={statusClass}>
          {result.status}
        </p>
      ) : null}
      {result.notice ? (
        <p role="status" className={noticeClass}>
          <span className="min-w-0 flex-1">{result.notice}</span>
          <button
            type="button"
            className="shrink-0 rounded p-0.5 hover:bg-hover"
            aria-label="Dismiss upload notice"
            onClick={onDismissNotice}
          >
            <X size={compact ? 9 : 12} />
          </button>
        </p>
      ) : null}
    </div>
  );
}
